import styles from './AgentTransferMessage.module.scss';

export default function AgentTransferMessage() {
    return (
        <p className={styles.text}>A care team member is on the way and will be with you shortly&hellip;</p>
    );
}
